export * from './core/index';
//# sourceMappingURL=core.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/material/core.js
// module id = 11
// module chunks = 0